export default "__VITE_ASSET__a7312d3e__"